import { Component, OnInit, ChangeDetectorRef, AfterViewInit, ViewChild } from '@angular/core';
import { ExceptionHelper } from '../../../../helper';
import { TranslateService } from '@ngx-translate/core';
import { ContractService } from '../contract.service';
import * as FileSaver from 'file-saver';
@Component({
  selector: 'app-contract-summary',
  templateUrl: './contract-summary.component.html',
  styleUrls: ['./contract-summary.component.css']
})
export class ContractSummaryComponent implements OnInit, AfterViewInit {
  @ViewChild('warningModal') warningModal: any;
  @ViewChild('successModal') successModal: any;
  isDownloading = false;
  redirect = false;
  contractArr = [];
  dataTable: any;
  selectedContract = {
    contractId: '',
    description: '',
  };
  constructor(
    private exception: ExceptionHelper,
    private translateService: TranslateService,
    private contractService: ContractService,
    private chRef: ChangeDetectorRef) {
    translateService.setDefaultLang('en-us');
  }

  ngAfterViewInit() {
    this.getSummary();
  }

  ngOnInit() {

  }


  getSummary() {

    this.contractService.getSummary().subscribe((data: any) => {

      if ($.fn.dataTable.isDataTable('#contractDataTables')) {
        $('#contractDataTables').DataTable().destroy();
      }

      this.contractArr = data;

      this.chRef.detectChanges();

      const table: any = $('#contractDataTables');
      this.dataTable = table.DataTable();
    }, error => {
      this.exception.showError(error, 'showDanModalBtn');
    });
  }

  closeSuccessModel() {
    this.successModal.hide();
    this.getSummary();
  }
  confirmContractRemoval() {
    this.warningModal.hide();
    const { contractId } = this.selectedContract;
    this.contractService.deleteContract(contractId).subscribe(res => {
      this.successModal.show();
      this.selectedContract['contractId'] = '';
      this.selectedContract['description'] = '';
    }, error => {
      this.exception.showError(error, 'showDanModalBtn');
      this.selectedContract['contractId'] = '';
      this.selectedContract['description'] = '';

    });
  }

  deleteContract(contractId, description): void {
    this.selectedContract['contractId'] = contractId;
    this.selectedContract['description'] = description;

    this.warningModal.show();
  }


  downloadContract(contractId, customerId) {
    this.isDownloading = true;
    this.contractService.getCustomerContractPDF(contractId, customerId).subscribe(res => {
      this.isDownloading = false;
      FileSaver.saveAs(res, 'contract.pdf');
    }, error => {
      this.exception.showError(error, 'showDanModalBtn');
      this.isDownloading = false;

    });

  }
}




// WEBPACK FOOTER //
// /Users/adminuser/Documents/pentagon/pentagon-admin/src/app/views/home/contract/contract-summary/contract-summary.component.ts